import { AxiosError } from 'axios';
import IAppErrorGraphQLResponse from '../interfaces/IAppErrorGraphQLResponse';

class AppErrorService {
	type: 'error' | 'axios' | 'graphql' = 'error';
	component?: string;
	error?: Error;
	errorJson?: object;
	name?: string;
	status?: number;
	message?: string;
	stack?: string;
	query?: string;
	queryVariables?: object[] = [];

	constructor(error: Error | AxiosError, component?: string) {
		if (component) {
			this.component = component;
		}
		this.type = 'error';
		this.error = error;

		if (error instanceof AxiosError) {
			this.type = 'axios';
			this.message = error.message;
			this.name = error.code;
			this.status = error?.response?.status;
			this.errorJson = error;
			this.query = error?.config?.method?.toUpperCase() + ' ' + error?.config?.baseURL + error?.config?.url;
			this.queryVariables = [];
			if (error?.config?.headers['Authorization']) {
				this.queryVariables.push({ Authorization: error.config.headers['Authorization'] });
			}
		} else {
			// `graphql-request` throws a `ClientError` whose shape isn't exported,
			// so we narrow with a structural cast instead of an instanceof check.
			const gqlError = error as unknown as {
				response?: IAppErrorGraphQLResponse;
				request?: { query?: string; variables?: object[] };
			};
			if (gqlError.response && gqlError.response.errors) {
				const graphQLError = gqlError.response;
				this.type = 'graphql';
				this.errorJson = graphQLError;
				this.status = graphQLError.status;
				this.query = gqlError.request?.query;
				this.queryVariables = gqlError.request?.variables;

				if (graphQLError.errors && graphQLError.errors[0] && graphQLError.errors[0].message) {
					this.message = graphQLError.errors[0].message;
				}
				if (this.message === 'unauthorized') {
					this.status = 401;
				}
			}
		}

		if (this.type === 'error') {
			this.message = error.message;
			this.stack = error.stack;
			this.name = error.name;
		}
	}

	getError = () => {
		return this.error;
	};

	getName = () => {
		return this.name;
	};

	getStack = () => {
		return this.stack;
	};

	getErrorJson = () => {
		return this.errorJson;
	};

	getComponent = () => {
		return this.component;
	};

	getQuery = () => {
		return this.query;
	};

	getQueryVariables = () => {
		return this.queryVariables;
	};

	getType = () => {
		return this.type;
	};

	getStatus = () => {
		return this.status;
	};

	getMessage = () => {
		return this.message;
	};
}

export default AppErrorService;
